// extracted by mini-css-extract-plugin
module.exports = {"SignUpModal":"SignUpModal__2LBK0","IconWrapper":"IconWrapper__30w_M"};